var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0054A6",
    d: "m10.815 9 6.793-6.793A1.284 1.284 0 1 0 15.793.392L9 7.185 2.207.392A1.283 1.283 0 0 0 .392 2.207L7.185 9 .392 15.793a1.283 1.283 0 1 0 1.815 1.815L9 10.815l6.793 6.793a1.283 1.283 0 0 0 1.815-1.815z"
  })));
};
export default SvgX;